{
  "id": "74jfu3ok-4785-9989-fkti-93kfi2j349f",
  "user_id": "7cc2e498-3274-4f0c-9a42-effc808df5a9",
  "name": "starter",
  "created_at": "2025-10-05T11:30:25.000Z",
  "config": {
    "valuation_update_frequency": "quarterly",
    "valuation_guides": "average",
    "auction_analytics": false,
    "ad_listing_analytics": false,
    "number_of_garages": 1,
    "cars_per_garage": 5,
    "garage_risk_kpis": false
  }
}